/* StoneCut 2026 – tema-JavaScript */
(function () {
  'use strict';
  var T = window.theme || { routes: {} };
  var R = T.routes;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fmt = function (cents) {
    return (Math.round(cents) / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  };
  var json = function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } };

  /* ---------- Privat / Erhverv ---------- */
  var KT_KEY = 'stonecut-kundetype';
  var getKt = function () { try { return localStorage.getItem(KT_KEY); } catch (e) { return null; } };
  var isB2B = function () { return T.vatToggle && getKt() === 'erhverv'; };

  function applyVat(root) {
    var b2b = isB2B();
    var rate = (Number(T.vatRate) || 0) / 100;
    $$('.s-money[data-money]', root).forEach(function (el) {
      var c = Number(el.getAttribute('data-money')) || 0;
      el.textContent = fmt(b2b ? c / (1 + rate) : c);
    });
    $$('[data-vat-of]', root).forEach(function (el) {
      var c = Number(el.getAttribute('data-vat-of')) || 0;
      el.textContent = fmt(c - c / (1 + rate));
    });
    document.documentElement.classList.toggle('erhverv', b2b);
    document.documentElement.classList.add('vat-ready');
    $$('[data-kundetype]').forEach(function (btn) {
      if (btn.hasAttribute('data-close-kt')) return;
      btn.setAttribute('aria-pressed', String((btn.getAttribute('data-kundetype') === 'erhverv') === b2b));
    });
  }

  function setKt(kind) {
    try { localStorage.setItem(KT_KEY, kind); } catch (e) {}
    applyVat();
    // Gemmes på kurven, så kundetypen står på ordren
    fetch(R.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Kundetype: kind === 'erhverv' ? 'Erhverv' : 'Privat' } })
    }).catch(function () {});
  }

  /* ---------- Lag: menu, søgning, kurv, kundetype ---------- */
  var lastFocus = null;
  function openLayer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    $$('.s-layer').forEach(function (l) { if (l !== el && !l.hidden && l.id !== 'CustomerType') closeLayer(l, true); });
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('s-lock');
    $$('[data-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('[data-predictive-input]', el) || $('button, a[href], input, select, textarea', el);
    if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function closeLayer(el, keepFocus) {
    if (!el || el.hidden) return;
    el.hidden = true;
    $$('[data-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!$$('.s-layer').some(function (l) { return !l.hidden; })) document.body.classList.remove('s-lock');
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.s-layer').forEach(function (l) { if (l.id !== 'CustomerType') closeLayer(l); });
      return;
    }
    if (e.key !== 'Tab') return;
    // Hold tastaturfokus inde i den åbne dialog
    var open = $$('.s-layer').filter(function (l) { return !l.hidden; });
    var layer = open[open.length - 1];
    if (!layer) return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', layer)
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!layer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Kurv ---------- */
  var drawer = function () { return document.getElementById('CartDrawer'); };
  function renderDrawer(html) {
    var d = drawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawer');
    if (!fresh) return;
    // Bevar fokus på samme knap (fx "+") efter opdateringen, så tastaturbrugere ikke mister pladsen
    var a = document.activeElement, focusSel = null;
    if (a && d.contains(a)) {
      if (a.hasAttribute('data-line-input')) focusSel = '[data-line-input="' + a.getAttribute('data-line-input') + '"]';
      else if (a.hasAttribute('data-line')) focusSel = '[data-line="' + a.getAttribute('data-line') + '"][aria-label="' + a.getAttribute('aria-label') + '"]';
    }
    d.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-count') || '0';
    d.setAttribute('data-count', count);
    $$('[data-cart-count]').forEach(function (c) { c.textContent = count; c.hidden = count === '0'; });
    $$('[data-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Kurv, ' + count + ' varer'); });
    applyVat(d);
    var f = focusSel && $(focusSel, d);
    if (f) f.focus(); else if (focusSel) { var c = $('button[data-close]', d); if (c) c.focus(); }
  }
  function showError(form, msg) {
    var box = form.parentNode && form.parentNode.querySelector('[data-form-error]');
    if (!box) box = $('[data-form-error]', form);
    if (box) { box.textContent = msg; box.hidden = !msg; }
  }
  function addToCart(form) {
    var btn = $('[type="submit"]', form);
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    if (btn) btn.classList.add('loading');
    showError(form, '');
    return fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (x) {
        if (!x.ok) throw new Error(x.d.description || x.d.message || 'Varen kunne ikke lægges i kurven.');
        if (x.d.sections) renderDrawer(x.d.sections['cart-drawer']);
        if (drawer()) openLayer('CartDrawer'); else window.location.href = R.cart;
      })
      .catch(function (e) { showError(form, e.message); })
      .then(function () { if (btn) btn.classList.remove('loading'); });
  }
  function changeLine(line, qty) {
    var d = drawer();
    var lines = d && $('[data-cart-lines]', d);
    if (lines) lines.classList.add('s-drawer-busy');
    return fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty) || 0), sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections['cart-drawer']);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () { window.location.href = R.cart; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('[data-product-form]')) {
      e.preventDefault();
      addToCart(form);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    if (!t) return;
    var open = t.getAttribute('data-open');
    if (open) { e.preventDefault(); openLayer(open); return; }
    if (t.hasAttribute('data-close') || (t.closest('.s-layer') && t.classList.contains('s-scrim'))) {
      e.preventDefault(); closeLayer(t.closest('.s-layer')); return;
    }
    if (t.hasAttribute('data-cart-open') && drawer() && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); openLayer('CartDrawer'); return;
    }
    if (t.hasAttribute('data-line') && t.hasAttribute('data-line-qty')) {
      e.preventDefault(); changeLine(t.getAttribute('data-line'), t.getAttribute('data-line-qty')); return;
    }
    if (t.hasAttribute('data-kundetype')) {
      setKt(t.getAttribute('data-kundetype'));
      if (t.hasAttribute('data-close-kt')) closeLayer(document.getElementById('CustomerType'));
      return;
    }
    if (t.hasAttribute('data-qty-step')) {
      var input = t.parentNode.querySelector('input[type="number"]');
      if (input) {
        var min = Number(input.min) || 1, max = Number(input.max) || 99;
        input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(t.getAttribute('data-qty-step'))));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
  document.addEventListener('click', function (e) {
    var s = e.target.classList && e.target.classList.contains('s-scrim') ? e.target : null;
    if (s && s.closest('.s-layer') && s.closest('.s-layer').id !== 'CustomerType') closeLayer(s.closest('.s-layer'));
  });
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (inp.hasAttribute && inp.hasAttribute('data-line-input')) changeLine(inp.getAttribute('data-line-input'), inp.value);
  });

  /* ---------- Søgning med forslag ---------- */
  var searchTimer = null, searchCtrl = null;
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.hasAttribute || !input.hasAttribute('data-predictive-input')) return;
    var box = $('[data-predictive-results]', input.closest('form'));
    clearTimeout(searchTimer);
    var q = input.value.trim();
    if (!q) { box.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      if (searchCtrl) searchCtrl.abort();
      searchCtrl = window.AbortController ? new AbortController() : null;
      fetch(R.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][prefix]=last&section_id=predictive-search', searchCtrl ? { signal: searchCtrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.getElementById('shopify-section-predictive-search');
          box.innerHTML = sec ? sec.innerHTML : '';
          applyVat(box);
        })
        .catch(function () {});
    }, 200);
  });

  /* ---------- Ringen (hulstørrelse) ---------- */
  function setRing(root, d) {
    if (!root || !d) return;
    var r = 48 + (d - 20) * 2.4;
    $$('circle.r', root).forEach(function (c) { c.setAttribute('r', r); });
    var line = $('line', root);
    if (line) { line.setAttribute('x1', 200 - r + 14); line.setAttribute('x2', 200 + r - 14); }
    var lbl = root.parentNode && $('[data-ring-label]', root.parentNode);
    if (lbl) lbl.textContent = 'Ø' + d;
  }

  /* ---------- Størrelsesvælger ---------- */
  function initFinder(sec) {
    var data = json($('[data-finder-data]', sec));
    if (!data || !data.sizes) return;
    var btns = $$('[data-finder-size-btn]', sec);
    function pick(i) {
      var s = data.sizes[i];
      if (!s) return;
      btns.forEach(function (b, k) { b.setAttribute('aria-pressed', String(k === i)); });
      $('[data-finder-size]', sec).textContent = 'Ø' + s.d;
      var price = $('[data-finder-price] .s-money', sec);
      if (price) price.setAttribute('data-money', s.price);
      $('[data-finder-id]', sec).value = s.id;
      var link = $('[data-finder-link]', sec);
      link.href = s.url;
      $('[data-finder-link-size]', sec).textContent = 'Ø' + s.d;
      var thumb = $('[data-finder-thumb] img', sec);
      if (thumb && s.img) { thumb.src = s.img; thumb.removeAttribute('srcset'); }
      var add = $('[data-finder-add]', sec);
      add.disabled = !s.available;
      add.textContent = s.available ? 'Læg i kurv' : 'Udsolgt';
      var note = $('[data-finder-note]', sec);
      var n = data.notes && data.notes[String(s.d)];
      note.textContent = n || '';
      note.hidden = !n;
      setRing($('[data-ring]', sec), s.d);
      applyVat(sec);
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { pick(Number(b.getAttribute('data-finder-size-btn'))); }); });
    var start = btns.findIndex(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
    pick(start < 0 ? 0 : start);
  }

  /* ---------- Produktside ---------- */
  function initProduct(root) {
    var data = json($('[data-product-json]', root));
    var form = $('#ProductForm', root);
    var gal = $('.s-gal', root);
    var galCol = gal && gal.parentNode;
    function showMedia(id) {
      if (!gal || !id) return;
      var items = $$('[data-media-id]', gal);
      var idx = items.findIndex(function (m) { return m.getAttribute('data-media-id') === String(id); });
      if (idx < 0) return;
      items.forEach(function (m) { m.hidden = m.getAttribute('data-media-id') !== String(id); });
      $$('[data-gal-to]', galCol).forEach(function (d) {
        var on = d.getAttribute('data-gal-to') === String(id);
        d.setAttribute('aria-current', String(on));
        if (on && d.classList.contains('s-thumb')) {
          var strip = d.parentNode;
          strip.scrollTo({ left: d.offsetLeft - (strip.clientWidth - d.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
      var count = $('[data-gal-count]', gal);
      if (count) count.textContent = (idx + 1) + ' / ' + items.length;
    }
    function stepMedia(dir) {
      var items = $$('[data-media-id]', gal);
      if (items.length < 2) return;
      var i = items.findIndex(function (m) { return !m.hidden; });
      showMedia(items[(i + dir + items.length) % items.length].getAttribute('data-media-id'));
    }
    if (gal) {
      galCol.addEventListener('click', function (e) {
        var to = e.target.closest('[data-gal-to]');
        var step = e.target.closest('[data-gal-step]');
        if (to) showMedia(to.getAttribute('data-gal-to'));
        if (step) stepMedia(Number(step.getAttribute('data-gal-step')));
      });
      // Swipe mellem billeder på mobil
      var x0 = null, y0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) stepMedia(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
    }
    // Den korteste kolonne følger med ved scroll (kun hvis den kan være på skærmen)
    var pd = $('.s-pd', root), info = $('.s-pd-info', root);
    function stick() {
      if (!pd || !galCol || !info) return;
      var desk = window.matchMedia('(min-width: 981px)').matches;
      var room = window.innerHeight - 100, g = galCol.offsetHeight, i = info.offsetHeight;
      pd.classList.toggle('stick-gal', desk && g < i && g <= room);
      pd.classList.toggle('stick-info', desk && i < g && i <= room);
    }
    stick();
    window.addEventListener('resize', stick);
    window.addEventListener('load', stick);
    $$('details', root).forEach(function (d) { d.addEventListener('toggle', stick); });
    var optBtns = $$('[data-option-index]', root);
    if (!data || !optBtns.length || !form) return;
    function selected() {
      var sel = [];
      optBtns.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') sel[Number(b.getAttribute('data-option-index'))] = b.getAttribute('data-option'); });
      return sel;
    }
    function update(fromUser) {
      var sel = selected();
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      sel.forEach(function (val, i) { var s = $('[data-option-value="' + i + '"]', root); if (s) s.textContent = val; });
      optBtns.forEach(function (b) {
        var i = Number(b.getAttribute('data-option-index'));
        var test = sel.slice(); test[i] = b.getAttribute('data-option');
        var ok = data.variants.some(function (x) { return x.available && x.options.every(function (o, k) { return o === test[k]; }); });
        b.classList.toggle('na', !ok);
      });
      var add = $('[data-add]', form);
      if (!v) { add.disabled = true; add.textContent = 'Ikke tilgængelig'; return; }
      $('[data-variant-id]', form).value = v.id;
      var price = $('[data-price] .s-money', root);
      if (price) price.setAttribute('data-money', v.price);
      var cmp = $('[data-compare]', root);
      if (cmp) {
        cmp.hidden = !(v.compare > v.price);
        cmp.innerHTML = v.compare > v.price ? '<span class="s-money" data-money="' + v.compare + '"></span>' : '';
      }
      var stock = $('[data-stock]', root);
      stock.classList.toggle('out', !v.available);
      $('[data-stock-text]', root).textContent = v.available ? data.stockText : 'Udsolgt';
      add.disabled = !v.available;
      add.textContent = v.available ? 'Læg i kurv' : 'Udsolgt';
      var dc = $('[data-dynamic-checkout]', root);
      if (dc) dc.hidden = !v.available;
      var sku = $('[data-sku]', root);
      if (sku) sku.textContent = v.sku || '';
      var d = parseInt(String(sel[0] || '').replace(/[^\d]/g, ''), 10);
      if (d) {
        setRing($('[data-ring]', root), d);
        var sd = $('[data-spec-dia]', root);
        if (sd) sd.textContent = 'Ø' + d + ' mm';
        $$('[data-note-size]', root).forEach(function (n) { n.hidden = Number(n.getAttribute('data-note-size')) !== d; });
      }
      if (v.media) showMedia(v.media);
      if (fromUser) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      applyVat(root);
    }
    optBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-option-index');
        $$('[data-option-index="' + i + '"]', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        update(true);
      });
    });
    update(false);
  }

  /* ---------- Kollektion: filter og sortering ---------- */
  function initCollection(root) {
    var cards = $$('[data-grid] .s-pc', root);
    var count = $('[data-count-txt]', root);
    var empty = $('[data-filter-empty]', root);
    $$('[data-filter]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-filter');
        $$('[data-filter]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        var shown = 0;
        cards.forEach(function (c) {
          var d = Number(c.getAttribute('data-dia')) || 0;
          var multi = c.getAttribute('data-multi') === '1';
          var ok = f === 'all' || (f === 'multi' ? multi : (function () { var p = f.split('-'); return d >= Number(p[0]) && d <= Number(p[1]); })());
          c.hidden = !ok;
          if (ok) shown++;
        });
        if (count) count.textContent = shown + (shown === 1 ? ' produkt' : ' produkter');
        if (empty) empty.hidden = shown > 0;
      });
    });
    var sort = $('[data-sort]', root);
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Faneblade (forhandler / fast-kunde) ---------- */
  function initTabs(root) {
    var tabs = $$('[data-tab]', root);
    function show(name) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === name;
        t.setAttribute('aria-selected', String(on));
        t.classList.toggle('on', on);
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.getAttribute('data-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        show(n.getAttribute('data-tab')); n.focus();
      });
    });
    function fromHash() {
      var h = (window.location.hash || '').replace('#', '');
      show(h === 'FastkundeForm' || h === 'fastkunde' ? 'fastkunde' : 'forhandler');
    }
    fromHash();
    window.addEventListener('hashchange', fromHash);
  }

  /* ---------- Forhandler- og fast-kunde-formularer ---------- */
  function initPartnerForms(root) {
    var hash = (window.location.hash || '').replace('#', '');
    $$('[data-partner-form]', root).forEach(function (form) {
      // Begge er kontaktformularer, så Shopify melder "sendt" til dem begge. Tak-beskeden vises kun ved den, der blev sendt.
      var ok = $('[data-form-ok]', form), err = $('[data-form-errors]', form), fields = $('[data-form-fields]', form);
      if (hash && hash !== form.id) {
        if (ok) ok.remove();
        if (err) err.remove();
        if (fields) fields.hidden = false;
      } else if (ok) {
        setTimeout(function () { ok.focus(); }, 50);
      }

      // Privat / Erhverv: firmanavn og CVR kun for erhverv
      var radios = $$('[data-kt-radio]', form), company = $('[data-company]', form);
      function syncCompany() {
        if (!company) return;
        var b2b = radios.some(function (r) { return r.checked && r.value === 'Erhverv'; });
        company.hidden = !b2b;
        $$('input', company).forEach(function (i) { i.disabled = !b2b; });
      }
      if (radios.length && getKt() === 'erhverv') radios.forEach(function (r) { r.checked = r.value === 'Erhverv'; });
      radios.forEach(function (r) { r.addEventListener('change', syncCompany); });
      syncCompany();

      // Fast-kunde: opret kunden i Shopify med mærket, samtidig med at e-mailen sendes
      if (form.hasAttribute('data-loyalty-form')) form.addEventListener('submit', function () {
        var body = new URLSearchParams();
        body.append('form_type', 'customer');
        body.append('utf8', '\u2713');
        $$('[data-customer]', form).forEach(function (i) { body.append('contact[' + i.getAttribute('data-customer') + ']', i.value.trim()); });
        var tags = [$('[data-customer-tags]', form).value];
        if (radios.some(function (r) { return r.checked && r.value === 'Erhverv'; })) tags.push('erhverv');
        body.append('contact[tags]', tags.join(', '));
        var url = R.root.replace(/\/$/, '') + '/contact';
        var sent = false;
        try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(url, body)); } catch (e) {}
        if (!sent) { try { fetch(url, { method: 'POST', body: body, keepalive: true, credentials: 'same-origin' }); } catch (e) {} }
      });
    });
  }

  /* ---------- Fast-kunde-rabat ---------- */
  function applyLoyalty() {
    var L = T.loyalty || {};
    if (!L.eligible || !L.code) return;
    try { if (sessionStorage.getItem('stonecut-loyalty') === L.code) return; } catch (e) {}
    fetch(R.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(L.code) + '?redirect=' + encodeURIComponent(R.cart + '.js'), { credentials: 'same-origin' })
      .then(function () { try { sessionStorage.setItem('stonecut-loyalty', L.code); } catch (e) {} })
      .catch(function () {});
  }

  function init() {
    applyVat();
    $$('[data-size-finder]').forEach(initFinder);
    $$('[data-product]').forEach(initProduct);
    $$('[data-collection]').forEach(initCollection);
    $$('[data-tabs]').forEach(function (t) { initTabs(t.parentNode); });
    initPartnerForms(document);
    applyLoyalty();
    if (T.vatToggle && !getKt() && document.getElementById('CustomerType') && !(window.Shopify && window.Shopify.designMode)) {
      setTimeout(function () { openLayer('CustomerType'); }, 600);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Tema-editoren: genstart komponenter, når en sektion genindlæses */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    $$('[data-size-finder]', t).forEach(initFinder);
    $$('[data-product]', t).forEach(initProduct);
    $$('[data-collection]', t).forEach(initCollection);
    applyVat(t);
  });
})();
